class Modals {
  #modalOpenElements = null;
  #openedModalElement = null;
  #modalName = null;
  #eventTimeout = 100;
  #scrollTop = null;

  constructor() {
    this.#modalOpenElements = document.querySelectorAll("[data-open-modal]");
  }

  init() {
    if (this.#modalOpenElements.length) {
      document.addEventListener("click", this.#documentClickHandler);
    }
    window.addEventListener("load", (event) => {
      let params = new URLSearchParams(document.location.search);
      let modalId = params.get("POPUP-ID");

      if (modalId) {
        this.open(modalId);
      }
    });
  }

  open = (modalName = this.#modalName) => {
    const modal = document.querySelector(`[data-modal="${modalName}"]`);

    if (!modal || modal.classList.contains("is-active")) {
      return;
    }

    document.removeEventListener("click", this.#documentClickHandler);

    this.#openedModalElement = document.querySelector(".modal.is-active");

    if (this.#openedModalElement) {
      this.close(this.#openedModalElement.dataset.modal);
    }

    if (this.#modalName === "nl-filter" && window.innerWidth > 1240) {
      modal.classList.add("is-active");
    } else {
      modal.classList.add("is-active");
      this.#disabledScroll();
    }

    setTimeout(() => {
      this.#addListeners(modal);
      document.addEventListener("click", this.#documentClickHandler);
    }, this.#eventTimeout);
  };

  close = (modalName = this.#modalName) => {
    const modal = document.querySelector(`[data-modal="${modalName}"]`);
    document.removeEventListener("click", this.#documentClickHandler);

    if (!modal || !modal.classList.contains("is-active")) {
      return;
    }

    modal.classList.remove("is-active");
    this.#removeListeners(modal);
    setTimeout(() => {
      if (this.#modalName === "nl-filter" && window.innerWidth > 1240) {
        document.body.classList.remove("scroll-lock");
        document.body.style.top = null;
        document.body.style.paddingRight = 0;
        document.addEventListener("click", this.#documentClickHandler);
      } else {
        this.#enableScroll();
        document.addEventListener("click", this.#documentClickHandler);
      }
    }, this.#eventTimeout);
  };

  #documentClickHandler = (evt) => {
    const target = evt.target;

    if (!target.closest("[data-open-modal]")) {
      return;
    }

    evt.preventDefault();

    this.#modalName = target.closest("[data-open-modal]").dataset.openModal;

    if (this.#modalName === "notification") {
      if (target.closest("[data-open-modal]").classList.contains("active")) {
        return;
      }
      document.querySelector('input[name="eventID"]').value =
        target.closest("[data-open-modal]").dataset.id;
    }

    if (!this.#modalName) {
      return;
    }

    this.open();
  };

  #addListeners = (modal) => {
    modal.addEventListener("click", this.#modalClickHandler);
    document.addEventListener("keydown", this.#documentKeydownHandler);
  };

  #removeListeners = (modal) => {
    modal.removeEventListener("click", this.#modalClickHandler);
    document.removeEventListener("keydown", this.#documentKeydownHandler);
  };

  #modalClickHandler = (evt) => {
    const target = evt.target;

    if (target.classList.contains("r-modal__wrapper")) {
      this.close(target.closest("[data-modal]").dataset.modal);
      return;
    }

    if (!target.closest("[data-close-modal]")) {
      return;
    }

    this.close(target.closest("[data-modal]").dataset.modal);
  };

  #documentKeydownHandler = (evt) => {
    const isEscKey = evt.key === "Escape" || evt.key === "Esc";

    if (isEscKey) {
      evt.preventDefault();
      this.close(document.querySelector(".r-modal.is-active").dataset.modal);
    }
  };

  #disabledScroll() {
    if (parseInt(document.body.style.top, 10)) {
      this.#scrollTop = parseInt(document.body.style.top, 10);
    } else {
      this.#scrollTop =
        self.pageYOffset ||
        (document.documentElement && document.documentElement.ScrollTop) ||
        (document.body && document.body.scrollTop);
    }

    const scrollWidth =
      window.innerWidth - document.documentElement.clientWidth;
    if (scrollWidth) {
      document.body.style.paddingRight = `${scrollWidth}px`;
    }
    document.body.style.top = `-${this.#scrollTop}px`;
    document.body.classList.add("scroll-lock");
  }

  #enableScroll() {
    if (document.querySelectorAll(".is-active").length === 1) {
      this.#scrollTop = parseInt(document.body.style.top, 10);
      document.body.classList.remove("scroll-lock");
      document.body.style.top = null;
      document.body.style.paddingRight = 0;
      window.scrollTo({
        top: this.#scrollTop * -1,
        left: 0,
        behavior: "instant",
      });
      this.#scrollTop = null;
    }

    if (document.querySelectorAll(".is-active").length === 0) {
      this.#scrollTop = parseInt(document.body.style.top, 10);
      document.body.classList.remove("scroll-lock");
      document.body.style.top = null;
      document.body.style.paddingRight = 0;
      window.scrollTo({
        top: this.#scrollTop * -1,
        left: 0,
        behavior: "instant",
      });
      this.#scrollTop = null;
    }
  }
}

const initModals = () => {
  const modals = new Modals();
  modals.init();
  window.appModals = modals;
};

export { initModals };
